import s from './Checkbox.module.css';
import { CheckboxProps } from '@/types/model';
import { AnimatePresence, motion } from 'framer-motion';
import { ErrorVariants } from '@/lib/variants';
import { useTranslations } from 'next-intl';

const Checkbox = ({ inputName, handleChange, checked, hasError, errorMessage }: CheckboxProps) => {
  const t = useTranslations('checkbox');

  return (
    <div className={s.container}>
      <input
        className={s.container__checkbox}
        type="checkbox"
        id={inputName}
        name={inputName}
        checked={checked}
        onChange={handleChange}
      />
      <label className={s.container__label} htmlFor={inputName}>
        <span>{t('label')}</span>
        <a href="/aviso-de-privacidad" target="_blank">
          {t('privacyLink')}
        </a>
      </label>
      <AnimatePresence initial={false}>
        {hasError && errorMessage && (
          <motion.span
            className={s.container__error_message}
            variants={ErrorVariants}
            initial="hide"
            animate="visible"
            exit="exit">
            {errorMessage}
          </motion.span>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Checkbox;
